/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HasPermissionResponse
 */
export interface HasPermissionResponse {
    /**
     * 
     * @type {string}
     * @memberof HasPermissionResponse
     */
    permission: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof HasPermissionResponse
     */
    hasPermission?: boolean;
}

/**
 * Check if a given object implements the HasPermissionResponse interface.
 */
export function instanceOfHasPermissionResponse(value: object): value is HasPermissionResponse {
    if (!('permission' in value) || value['permission'] === undefined) return false;
    return true;
}

export function HasPermissionResponseFromJSON(json: any): HasPermissionResponse {
    return HasPermissionResponseFromJSONTyped(json, false);
}

export function HasPermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HasPermissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'permission': json['permission'],
        'hasPermission': json['hasPermission'] == null ? undefined : json['hasPermission'],
    };
}

export function HasPermissionResponseToJSON(json: any): HasPermissionResponse {
    return HasPermissionResponseToJSONTyped(json, false);
}

export function HasPermissionResponseToJSONTyped(value?: HasPermissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permission': value['permission'],
        'hasPermission': value['hasPermission'],
    };
}

